<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  <title>408 - Access Denegado - Desconexión por inactividad</title>
</head>

<body>
  <div class="cover">
    <h1>DESCONEXIÓN POR INACTIVIDAD (Timeout) </h1>
    <p class="lead"> Su tiempo de inactividad excedió los 10 minutos por lo que se ha procedido
        a cerrar su sesión, por favor vuelva a ingresar con su usuario y contraseña.</p>
  </div>

</body>

</html>